import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { i18n } from 'fishx';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { showTotal } from '@/utils';
import { Button, Input, Form, Table } from '@whalecloud/fdx';
import CommonModal from '@/components/CommonModal';
import styles from './index.module.less';

const RefInput = forwardRef((props, ref) => (
  <Input ref={ref} {...props} />
));

const defaultSearchInfo = {
  bankName: '',
  bankCode: '',
  pageSize: 10,
  current: 1,
};

const defaultTotal = 0;

const BankSelect = props => {
  const refInput = useRef();
  const {
    placeholder = i18n('COMMON_SELECT_ICON'),
    form,
    value,
    onChange,
    modelName,
    ...preProps
  } = props;
  const { getFieldDecorator, resetFields, validateFields } = form;
  const dispatch = useDispatch();
  const loading = useSelector(state => (state.loading.effects['business/qryBankList']));
  const [visible, setVisible] = useState(false); // 弹框显示
  const [searchInfo, setSearchInfo] = useState({ ...defaultSearchInfo }); // 分页
  const [total, setTotal] = useState(defaultTotal);
  const [list, setList] = useState([]); // 列表
  const [current, setCurrent] = useState({});

  useEffect(() => {
    if (!visible) {
      refInput.current.blur();
    }
  }, [visible]);

  useEffect(() => {
    // 触发查询
    handleSearchInfoChange();
  }, [searchInfo]);

  const handleRowClick = record => {
    setCurrent(record);
  };

  const handleSearchInfoQuery = () => {
    validateFields().then(formInfo => {
      const { bankName, bankCode } = formInfo;
      setSearchInfo({ ...defaultSearchInfo, bankName, bankCode });
    });
  };

  const handleSearchInfoReset = async () => {
    resetFields();
    setSearchInfo(defaultSearchInfo);
  };

  const handleSearchInfoChange = async () => {
    const { pageDto, bankDtoList } = await dispatch({
      type: 'business/qryBankList',
      payload: {
        bankName: searchInfo.bankName,
        bankCode: searchInfo.bankCode,
        pageDto: {
          pageIndex: searchInfo.current,
          pageCount: searchInfo.pageSize,
        },
      },
      modelName,
    });
    setList(bankDtoList || []);
    if (get(pageDto, 'pageIndex') === 1) {
      // 只有第一页返回总数
      setTotal(get(pageDto, 'totalRecord'));
    }
  };

  const handlePageChage = (page, pageSize) => {
    setSearchInfo({ ...searchInfo, pageSize, current: page });
  };

  const handleSubmit = () => {
    if (isEmpty(current)) {
      return;
    }
    onChange(current.bankId, current);
    setVisible(false);
  };

  const columns = [
    {
      title: i18n('SEARCH_BANK_NAME'),
      dataIndex: 'bankName',
    },
    {
      title: i18n('SEARCH_BANK_CODE'),
      dataIndex: 'bankCode',
    },
    {
      title: i18n('SEARCH_IFSC'),
      dataIndex: 'ifsc',
    },
    {
      title: i18n('SEARCH_MICR'),
      dataIndex: 'micr',
    },
  ];

  return (
    <>
      <RefInput
        ref={refInput}
        value={get(list.find(item => `${item.bankId}` === `${value}`), 'bankName')}
        placeholder={placeholder}
        autoComplete="off"
        onClick={() => setVisible(true)}
        suffix={<span className="iconfont2 iconsend" style={{ color: '#ABACB2' }} onClick={() => setVisible(true)} />}
        {...preProps}
      />
      {visible && (
        <CommonModal
          modalOpts={{
            title: i18n('SEARCH_SELECT_BANK'),
            footer: [
              <Button onClick={() => setVisible(false)} key="COMMON_CANCEL">{i18n('COMMON_CANCEL')}</Button>,
              <Button type="primary" onClick={handleSubmit} key="COMMON_SUBMIT">{i18n('COMMON_SUBMIT')}</Button>,
            ],
            draggable: false,
            onCancel: () => setVisible(false),
            width: 1400,
            className: `threeColumnWrap ${styles.bankSelectModal}`,
          }}
        >
          <Form layout="inline">
            <Form.Item label={i18n('SEARCH_BANK_NAME')}>
              {getFieldDecorator('bankName', {
              })(<Input placeholder={i18n('PLEASE_INPUT')} />)}
            </Form.Item>
            <Form.Item label={i18n('SEARCH_BANK_CODE')}>
              {getFieldDecorator('bankCode', {
              })(<Input placeholder={i18n('PLEASE_INPUT')} />)}
            </Form.Item>
            <Form.Item className={styles.searchBtn} label="">
              <Button type="primary" onClick={() => handleSearchInfoQuery()}>{i18n('BTN_QUERY')}</Button>
              <Button onClick={() => handleSearchInfoReset()}>{i18n('BTN_RESET')}</Button>
            </Form.Item>
          </Form>
          <Table
            loading={loading}
            columns={columns}
            dataSource={list}
            rowKey="bankId"
            highlightRow={list.find(item => `${item.bankId}` === `${value}`)}
            onRow={record => ({
              onClick: () => handleRowClick(record),
            })}
            pagination={{
              showQuickJumper: true,
              showTotal,
              total,
              pageSize: searchInfo.pageSize,
              current: searchInfo.current,
              onChange: handlePageChage,
            }}
          />
        </CommonModal>
      )}
    </>
  );
};

export default Form.create({ name: 'bank-select' })(BankSelect);
